import React from "react";
import LegalPage, { useLegalInfo, Val, MissingFieldsBlock } from "./LegalPage";

export default function UseTerms() {
  const info = useLegalInfo();
  return (
    <LegalPage overline="Document légal" title="Conditions d'utilisation">
      <p><strong>Effective :</strong> <Val info={info} k="TERMS_EFFECTIVE_DATE" /></p>

      <h2>1. Objet</h2>
      <p>
        Le Révélateur™ est un instrument propriétaire de lecture stratégique développé par Maison Beaudette™.
        Il propose un questionnaire éditorial et un Rapport de Révélation Stratégique™ personnalisé.
      </p>

      <h2>2. Clientèle visée et âge minimal</h2>
      <p>
        Le Révélateur™ s'adresse à une clientèle professionnelle (dirigeantes et dirigeants d'entreprise,
        entrepreneurs, professionnels). L'utilisation est réservée aux personnes âgées d'au moins 18 ans.
      </p>

      <h2>3. Utilisation permise</h2>
      <ul>
        <li>Utilisation personnelle et professionnelle des livrables reçus, à l'intérieur de votre organisation.</li>
        <li>Vous êtes responsable de l'exactitude des informations et des réponses fournies.</li>
        <li>Si un compte ou un lien privé vous est confié, la confidentialité de vos identifiants et de vos liens d'accès vous incombe.</li>
      </ul>

      <h2>4. Propriété intellectuelle</h2>
      <p>
        La Méthode MB™, la marque Maison Beaudette™, la marque Le Révélateur™, les structures d'analyse,
        les gabarits éditoriaux, les designs, les textes, les icônes et l'ensemble des livrables demeurent la
        propriété exclusive de Maison Beaudette™. Sauf usage interne du Rapport de Révélation Stratégique™
        généré pour vous, toute reproduction, revente, extraction automatisée, ingénierie inverse ou usage
        commercial dérivé est interdit sans autorisation écrite préalable.
      </p>

      <h2>5. Absence d'avis juridique, fiscal, financier ou comptable</h2>
      <p>
        Le contenu du Révélateur™ ne constitue pas un avis juridique, fiscal, financier ou comptable. Pour
        toute décision engageante, consultez un professionnel qualifié dans le domaine concerné.
      </p>

      <h2>6. Absence de garantie commerciale</h2>
      <p>
        La lecture stratégique proposée est une interprétation éditoriale à partir de vos réponses. Aucun
        résultat commercial n'est garanti.
      </p>

      <h2>7. Disponibilité et maintenance</h2>
      <p>
        Nous nous efforçons de maintenir la plateforme accessible. Des interruptions ponctuelles pour
        maintenance, mise à jour ou raison de force majeure peuvent survenir. Nous informons dans la mesure
        du possible en cas d'interruption prolongée.
      </p>

      <h2>8. Comportements interdits</h2>
      <ul>
        <li>Détourner ou tester la sécurité de la plateforme.</li>
        <li>Extraire automatiquement le contenu (scraping, robots, scripts).</li>
        <li>Contourner les mécanismes de paiement.</li>
        <li>Utiliser des identités ou renseignements d'autrui sans autorisation.</li>
        <li>Diffuser des contenus illicites, offensants ou trompeurs via les champs libres du questionnaire.</li>
      </ul>

      <h2>9. Suspension en cas d'abus</h2>
      <p>
        Maison Beaudette™ peut suspendre l'accès en cas de comportement contraire aux présentes conditions
        ou à la loi, sans que cela ne prive l'utilisateur de ses droits impératifs.
      </p>

      <h2>10. Droit applicable et compétence</h2>
      <p>
        Sauf dispositions impératives contraires, les présentes sont régies par le droit applicable au Québec
        (Canada). Les tribunaux compétents du district judiciaire du siège de Maison Beaudette™ sont désignés,
        sous réserve des droits impératifs du consommateur.
      </p>

      <h2>11. Soutien et plaintes</h2>
      <p>
        Courriel : <Val info={info} k="SUPPORT_EMAIL" /><br />
        Téléphone : <Val info={info} k="BUSINESS_PHONE" />
      </p>

      <MissingFieldsBlock info={info} />
    </LegalPage>
  );
}
